import { SnackbarEvents } from "@gtmhub/shared/components/ui/snackbar/snackbar.events";
import { IScope, IRootScopeService, IPromise, IQService } from "angular";
import { UserProfileService } from "../profileService";
import { IProfile } from "@webapp/users/models/users.models";
import { CurrentUserService } from "../../currentUserService";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IUser } from "../../models";
import { UserService } from "../../userService";
import { ILanguageMap, filterLanguages } from "@gtmhub/localization";
import { IStateInit } from "@gtmhub/core/routing";
import { getCurrentUserId } from "../../current-user-storage";
import { LanguagesConfigService } from "@gtmhub/localization/services/languages-config.service";
import languages from "wwwroot/json/languages.json";

export interface IUserLanguageScope extends IScope {
  profile: IProfile;
  indicators;
  user: IUser;
  supportedLanguages: ILanguageMap;
  initialLanguage: string;
  setLanguage(language: string): void;
}

export class UserLanguageCtrl implements IStateInit {
  private snackbarEvents: SnackbarEvents;

  public static $inject = ["$rootScope", "$scope", "$q", "CurrentUserService", "UserService", "UserProfileService", "UIErrorHandlingService", "LanguagesConfigService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: IUserLanguageScope,
    private $q: IQService,
    private currentUserService: CurrentUserService,
    private userService: UserService,
    private profileService: UserProfileService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private languagesConfigService: LanguagesConfigService
  ) {
    this.snackbarEvents = new SnackbarEvents($scope);
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private init = (): IPromise<unknown> => {
    this.$scope.indicators = {};
    this.$scope.setLanguage = this.setLanguage;

    this.loadUser();
    this.subscribeForProfileUpdate();

    this.$scope.indicators.user = true;
    return this.$q.all([this.getUser(), this.loadSupportedLanguages()]).then(() => (this.$scope.indicators.user = false));
  };

  private loadUser = () => {
    this.$scope.profile = this.profileService.getProfile();
  };

  private getUser = (): IPromise<unknown> => {
    return this.userService.getUser(getCurrentUserId()).then((user) => {
      this.$scope.user = user;
      this.setInitialLanguage(user.language);
    });
  };

  private loadSupportedLanguages = (): IPromise<ILanguageMap> => {
    return this.languagesConfigService
      .getLanguageMap()
      .then((languageMap) => (this.$scope.supportedLanguages = languageMap))
      .catch(() => (this.$scope.supportedLanguages = filterLanguages("italian", languages.languageMap)));
  };

  private setInitialLanguage = (language: string) => {
    this.$scope.initialLanguage = language;
  };

  private subscribeForProfileUpdate = () => {
    const removeUserProfileUpdatedListener = this.$rootScope.$on("userProfileUpdated", (evnt, profile: IProfile) => {
      this.$scope.profile = profile;
    });

    this.$scope.$on("$destroy", removeUserProfileUpdatedListener);
  };

  private setLanguage = (language: string) => {
    this.$scope.indicators.saving = true;

    const userSettings = {
      language: language,
    };

    this.userService.updateUserSettings(this.$scope.user.id, userSettings).then(
      () => {
        this.$scope.indicators.saving = false;
        this.currentUserService.raiseProfileLanguageUpdated(language);
        this.currentUserService.setUserLanguage(language);
        this.setInitialLanguage(userSettings.language);
        this.snackbarEvents.broadcastShowSnackbar("language_updated");
        location.reload();
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "saving", inline: true })
    );
  };
}
